export enum EBookletStatus {
  'NEW' = 'NEW',
  'DUE_DILIGENCE' = 'DUE_DILIGENCE',
  'DOC_READY' = 'DOC_READY',
  'ARCHIVED' = 'ARCHIVED',
  'INACTIVE' = 'INACTIVE',
  'AUTO' = 'AUTO',
}
